import { accountApi } from "./accountApi";
import { categorySourceApi } from "./categorySourceApi";
import { crmHocSinhApi } from "./crmHocSinhApi";
import { dictionaryApi } from "./dictionaryApi";
import { diemDanhApi } from "./diemDanhApi";
import { diemDanhStatusApi } from "./diemDanhStatusApi";
import { hocSinhApi } from "./hocSinhApi";
import { localizedReourceApi } from "./localizedReourceApi";
import { lopApi } from "./lopApi";
import { notifyApi } from "./notifyApi";
import { phongNamhocApi } from "./phongNamhocApi";
import { thoiKhoaBieuApi } from "./thoiKhoaBieuApi";
import { thoiKhoaBieuChiTietApi } from "./thoiKhoaBieuChiTietApi";
import { tietApi } from "./tietApi";
import { tuanApi } from "./tuanApi";
import { uploadApi } from "./uploadApi";
export const apiWrapper = {
  account: accountApi,
  uploadFile: uploadApi,
  categorySource: categorySourceApi,
  dictionary: dictionaryApi,
  lop: lopApi,
  hocSinh: hocSinhApi,
  notify: notifyApi,
  localizedResource: localizedReourceApi,
  crmHocSinh: crmHocSinhApi,
  thoiKhoaBieu: thoiKhoaBieuApi,
  thoiKhoaBieuChiTietApi: thoiKhoaBieuChiTietApi,
  tuan: tuanApi,
  tiet: tietApi,
  phongNamhoc: phongNamhocApi,
    diemDanh: diemDanhApi,
    diemDanhStatus: diemDanhStatusApi,
};
